/** Line icons for the menu (16 px, stroke = text colour). Keyed by the menu path. */
const PATHS: Record<string, string> = {
  // summary: a clipboard with lines
  '/podsumowanie': 'M8 4.5H6v16h12v-16h-2M8 3h8v3H8zM9 10.5h6M9 14h6M9 17.5h4',
  '/wydarzenia': 'M4 6.5h16v13.5H4zM4 10.5h16M8.5 3.5v4M15.5 3.5v4',
  // my calendar: a calendar with a person's dot
  '/moj-kalendarz': 'M4 6.5h16v13.5H4zM4 10.5h16M8.5 3.5v4M15.5 3.5v4M12 13.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5z',
  // new event: a calendar with a plus
  '/nowa-impreza': 'M4 6.5h16v13.5H4zM4 10.5h16M8.5 3.5v4M15.5 3.5v4M12 13v5M9.5 15.5h5',
  // company tasks: a ticked box with lines (a to-do list)
  '/zadania': 'M4 5.5h4v4H4zM5 7.5l1 1 2-2.5M11 7.5h9M4 14.5h4v4H4zM11 16.5h9',
  '/wyceny': 'M6 3.5h9l3 3v14H6zM9 11h6M9 14.5h6M9 18h3',
  '/katalog': 'M20.5 7.5 12 3 3.5 7.5 12 12zM3.5 7.5v9L12 21l8.5-4.5v-9M12 12v9',
  '/zestawy': 'M4 4h6.5v6.5H4zM13.5 4H20v6.5h-6.5zM4 13.5h6.5V20H4zM13.5 13.5H20V20h-6.5z',
  // blocks and templates: stacked layers
  '/szablony': 'M12 3.5 3.5 8 12 12.5 20.5 8zM3.5 12 12 16.5 20.5 12M3.5 16 12 20.5 20.5 16',
  // rules: "if this, then that" — a branching arrow
  '/reguly': 'M5 6h6l3 6h5M14 12l-3 6H5M16 9l3 3-3 3',
  // price lists: a price tag
  // finance: a rising line over an axis
  '/finanse': 'M4 4v16h16M7.5 15l3.5-4 3 2.5 5-6M16 7.5h3v3',
  '/dostepnosc': 'M3 12h4l3-7 4 14 3-7h4',
  '/kontrahenci': 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6M16 4.3a3.5 3.5 0 0 1 0 6.4M18 14.4c2 .8 3.5 2.8 3.5 5.6',
  // people: a person with a badge (functions)
  '/osoby': 'M10 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3.5 20c0-3.6 2.9-6 6.5-6 1.4 0 2.7.4 3.7 1M15.5 14.5h5v5.5h-5zM17 14.5V13h2v1.5',
  '/uzytkownicy': 'M12 11.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4.5 20.5c0-4 3.4-6.5 7.5-6.5s7.5 2.5 7.5 6.5',
  // sending notifications: a paper plane
  '/powiadomienia/wysylka': 'M20.5 3.5 3.5 10.5l7 2.5 2.5 7zM10.5 13l10-9.5',
  '/tresc-podpowiedzi': 'M4 5h16v11H9l-5 4zM8 9h8M8 12h5',
  // "Więcej" on the phone tab bar
  more: 'M5 12h.01M12 12h.01M19 12h.01',
  // sliders: company settings (warehouse, systems, checklists)
  '/ustawienia': 'M4 7h9M17 7h3M4 17h3M11 17h9M15 5v4M9 15v4',
  '/uprawnienia': 'M12 3 4.5 6v5.5c0 4.5 3.2 8 7.5 9.5 4.3-1.5 7.5-5 7.5-9.5V6zM9 12l2 2 4-4',
};

export function MenuIcon({ to }: { to: string }) {
  const d = PATHS[to];
  if (!d) return null;
  return (
    <svg className="menu-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={to === 'more' ? 3 : 1.6} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={d} />
    </svg>
  );
}
